import { UsuarioTableType } from "components/tables/UsuarioTable";

// Definição dos itens de navegação (breadcrumb)
export const usuariosBreadcrumbItems = [
  { label: "Cadastros", to: "/cadastros" },
  {
    label: "Usuários",
    active: true,
  }
];

// Interfaces para comunicação com a API
export interface UsuarioApiResponse {
  data: UsuarioTableType[];
  isSuccess: boolean;
  message: string;
}

export interface UsuarioCreateRequest {
  nome: string;
  email: string;
  senha: string;
  grupoId: number;
}

export interface UsuarioUpdateRequest {
  nome: string;
  email: string;
  grupoId: number;
}

export interface UsuarioCreatedResponse {
  id: number;
  codigo: number;
  nome: string;
  email: string;
  grupoId: number;
}

export interface UsuarioUpdatedResponse {
  id: number;
  codigo: number;
  nome: string;
  email: string;
  grupoId: number;
}

export interface UsuarioDetailResponse {
  id: number;
  codigo: number;
  nome: string;
  email: string;
  grupoId: number;
}